var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBedrooms = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 36,
  height: 36,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFCAA1",
  d: "M14.125 12h-3.547a2.11 2.11 0 0 0-2.11 2.11v2.832h7.767v-2.833A2.11 2.11 0 0 0 14.125 12M25.422 12h-3.547a2.11 2.11 0 0 0-2.11 2.11v2.832h7.767v-2.833A2.11 2.11 0 0 0 25.422 12"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#6E3037",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "m9.175 30.356-.93 1.859a1.745 1.745 0 0 1-3.306-.78v-1.08M26.826 30.356l.93 1.859a1.745 1.745 0 0 0 3.306-.78v-1.08M33.885 25.413V22.59a5.65 5.65 0 0 0-5.648-5.648H7.763a5.65 5.65 0 0 0-5.648 5.648v2.824"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#6E3037",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "M2.115 22.589V4.232a1.412 1.412 0 1 1 2.824 0v13.465M31.06 17.697V4.232a1.412 1.412 0 1 1 2.825 0V22.59"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#6E3037",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "M4.94 7.761c9.102-3.902 17.665-3.625 26.121 0"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFCAA1",
  d: "M33.885 31.06H2.115A2.12 2.12 0 0 1 0 28.943v-2.118c0-1.166.949-2.115 2.115-2.115h31.77c1.166 0 2.115.949 2.115 2.115v2.118a2.12 2.12 0 0 1-2.115 2.115"
})));
export default SvgBedrooms;